export default __webpack_public_path__ + "static/media/Fila.c70c9acd.png";